<template>
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">팀 설정</span>
            <span class="txt">팀 이름을 설정하고, 팀원을 추가 및 이동할 수 있습니다.</span>
        </div>
        <div class="com-search-content">
            <div class="line">
                <div class="com-search-input">
                    <input placeholder="이름 입력" type="text" />
                    <button class="search-btn">검색</button>
                </div>
            </div>
        </div>

        <div class="member-group-content">
            <span class="title">팀명</span>
            <div class="check-area">
                <div class="check-btn">
                    <div class="com-radio-txt">
                        <input
                            id="check-team-no"
                            v-model="selectedTeamId"
                            checked
                            name="check-team"
                            type="radio"
                            value=""
                        />
                        <label for="check-team-no">소속없음</label>
                    </div>
                    <template v-for="(item, index) in data">
                        <div :key="index" class="com-radio-txt">
                            <input
                                :id="`check-team-${item.centerTeamId}`"
                                v-model="selectedTeamId"
                                :value="item.centerTeamId"
                                name="check-team"
                                type="radio"
                            />
                            <label :for="`check-team-${item.centerTeamId}`">{{ item.name }}</label>
                        </div>
                    </template>
                    <button class="com-setting-btn" type="button" @click="teamPop = true">
                        <span class="blind">설정</span>
                    </button>
                </div>
            </div>
        </div>

        <div class="employee-card-list check-type">
            <span class="title">소속된 팀원</span>
            <div class="btn-area">
                <button class="com-btn blue" type="button" @click="teamSettingPop = true">팀 설정</button>
                <button :disabled="selectedTeamId == ''" class="com-btn blue" type="button" @click="removeStaffTeams">
                    팀 제외
                </button>
            </div>
            <loading-spinner v-if="isLoading"></loading-spinner>
            <ul v-else-if="staffs.length > 0" class="select-photo-list">
                <li v-for="(item, index) in staffs" :key="index">
                    <span class="box">
                        <div class="com-check">
                            <input
                                :id="`check-staff-${item.c_center_staff_id}`"
                                v-model="selectedStaffs"
                                :value="item.c_center_staff_id"
                                name="selected-staffs"
                                type="checkbox"
                            />
                            <label :for="`check-staff-${item.c_center_staff_id}`"></label>
                        </div>
                        <img :src="item.c_img_url || '/img/temp/no_photo.jpg'" alt="" @error="imageUrlAlt" />
                        <span class="name">{{ item.c_namee }}</span>
                        <span class="tel">{{ item.c_phone | phoneNumberFilter }}</span>
                        <span class="type">{{ item.r_role_nm || '-' }}</span>
                        <span class="detail">
                            {{ (item.centerStaffTeams || []).map((o) => o.centerTeam.name).join('/') }}
                        </span>
                    </span>
                </li>
            </ul>
            <p v-else class="no-msg">소속된 직원이 없습니다.</p>
        </div>

        <!-- 팀명 추가 팝업 -->
        <div v-show="teamPop" class="layer-pop square-type">
            <div class="view-content">
                <button class="close" @click="teamPop = false"><span class="blind">팝업 닫기</span></button>
                <div class="scroll-area com-scroll-y">
                    <span class="sub-title">팀명 설정</span>
                    <p class="sub-txt">
                        팀명의 이름을 추가, 수정 및 삭제 할 수 있습니다.
                        <br />
                        팀명 삭제 시, 해당 팀 소속이었던 직원은 소속없음 카테고리로 자동분류 됩니다.
                    </p>
                    <div class="del-box">
                        <div class="input-cnt flex-col">
                            <div v-for="(item, index) in dataEditTeam" :key="index" class="line">
                                <input v-model="item.name" type="text" />
                                <button
                                    v-if="dataEditTeam.length > 1"
                                    class="com-btn"
                                    type="button"
                                    @click="removeTeam(item, index)"
                                >
                                    삭제
                                </button>
                            </div>
                        </div>
                        <div class="add-btn-cnt">
                            <div class="line">
                                <button class="com-btn" type="button" @click="addTeam">+추가</button>
                            </div>
                        </div>
                    </div>
                    <div class="bottom-btn">
                        <button class="com-btn" type="button" @click="teamPop = false">취소</button>
                        <button class="com-btn blue" type="button" @click="saveTeam">저장</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- 팀 설정 팝업 -->
        <div v-show="teamSettingPop" class="layer-pop square-type">
            <div class="view-content">
                <button class="close" @click="teamSettingPop = false"><span class="blind">팝업 닫기</span></button>
                <div class="scroll-area com-scroll-y">
                    <span class="sub-title">팀 설정</span>
                    <p class="sub-txt">
                        선택한 직원의 팀을 설정합니다. 직원별 중복으로 팀 설정이 가능합니다.
                        <br />
                        예를 들어 홍길동 직원의 경우, A팀과 B팀에 모두 팀원으로 설정할 수 있습니다.
                    </p>
                    <div class="check-design-box">
                        <div class="input-cnt flex-col">
                            <div v-for="(item, index) in data" :key="index" class="line">
                                <input
                                    :id="`selected-items-${item.centerTeamId}`"
                                    v-model="selectedTeams"
                                    :value="item.centerTeamId"
                                    name="check-teams"
                                    type="checkbox"
                                />
                                <label :for="`selected-items-${item.centerTeamId}`">{{ item.name }}</label>
                            </div>
                        </div>
                        <p class="info-txt">팀을 2개 이상 선택할 수 있습니다.</p>
                    </div>
                    <div class="bottom-btn">
                        <button class="com-btn" type="button" @click="teamSettingPop = false">취소</button>
                        <button class="com-btn blue" type="button" @click="saveStaffTeams">설정</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import api from '@/assets/js/api';
import LoadingSpinner from '../../../components/LoadingSpinner';
import BtnLoadingSpinner from '../../../components/BtnLoadingSpinner';

export default {
    name: 'SettingEmployeeTeam',
    components: { LoadingSpinner, BtnLoadingSpinner },
    props: {},
    computed: {
        centerId() {
            const { getters } = this.$store;
            return getters['auth/cId'];
        },
        dataEditTeam() {
            return this.dataEdit.filter((o) => !o.removed);
        },
    },
    data() {
        return {
            isLoading: false,
            isSaving: false,
            teamPop: false,
            teamSettingPop: false,
            centerStaffId: this.$route.params.centerStaffId,
            selectedTeamId: null,
            selectedTeams: [],
            selectedStaffs: [],
            data: [],
            dataEdit: [],
            staffs: [],
        };
    },
    watch: {
        teamSettingPop(v) {
            if (v && this.selectedStaffs.length == 0) {
                alert('팀 설정을 할 직원을 선택해주세요.');
                this.teamSettingPop = false;
            }
        },
        selectedTeamId(v) {
            this.loadStaff();
        },
        teamPop(v) {
            if (v) {
                this.dataEdit = eval(`(${JSON.stringify(this.data)})`);
                if (this.dataEdit.length == 0) {
                    this.dataEdit.push({ index: 0 });
                }
            }
        },
    },
    beforeMount() {
        this.load();
        this.selectedTeamId = '';
    },
    mounted() {},
    methods: {
        load() {
            this.isLoading = true;
            // 스웨거 검색: 센터팀 조회
            api.get(`/admin/api/center/${this.centerId}/team`)
                .then((res) => {
                    this.isLoading = false;
                    this.data = res.data;
                })
                .catch((res) => {
                    this.isLoading = false;
                    // if (res.response.status != 404) alert(`오류가 발생했습니다.\n${res.response.data.message}`);
                    console.error(res);
                });
        },
        loadStaff() {
            const mode = this.selectedTeamId ? 'all/pagaing' : 'noTeamStaffs/all';
            this.isLoading = true;
            api.get(`/admin/api/center/${this.centerId}/staff/${mode}`, {
                params: {
                    page: 1,
                    limit: 10000,
                    centerTeamId: this.selectedTeamId,
                },
            })
                .then((res) => {
                    this.isLoading = false;
                    this.staffs = res.data.items || res.data;
                    console.log('================');
                    this.staffs = this.staffs.filter((staff) => staff.c_status_cd === 'I');
                })
                .catch((res) => {
                    this.isLoading = false;
                    // if (res.response.status != 404) alert(`오류가 발생했습니다.\n${res.response.data.message}`);
                    console.error(res);
                });
        },
        addTeam() {
            this.dataEdit.push({
                index: Math.max(0, ...this.dataEdit.map((o) => o.index || 0)) + 1,
            });
        },
        removeTeam(item, index) {
            if (item.centerTeamId) {
                this.$set(item, 'removed', true);
            } else {
                this.dataEdit.splice(index, 1);
            }
        },
        saveTeam() {
            if (this.dataEdit.filter((o) => o.name == '').length > 0) {
                alert('팀명을 입력해주세요.');
                return;
            }
            const requests = [];
            this.dataEdit.forEach((o) => {
                if (o.centerTeamId == undefined) {
                    requests.push(api.post(`/admin/api/center/${this.centerId}/team`, o));
                } else if (o.removed) {
                    requests.push(api.delete(`/admin/api/center/${this.centerId}/team/${o.centerTeamId}`));
                } else {
                    requests.push(api.put(`/admin/api/center/${this.centerId}/team/${o.centerTeamId}`, o));
                }
            });
            if (requests.length == 0) return;
            this.isSaving = true;
            axios
                .all(requests)
                .then(
                    axios.spread((...res) => {
                        this.isSaving = false;
                        this.teamPop = false;
                        this.load();
                    })
                )
                .catch((res) => {
                    this.isSaving = false;
                    if (res.response.status != 404) alert(`오류가 발생했습니다.\n${res.response.data.message}`);
                    console.error(res);
                });
        },
        saveStaffTeams() {
            if (this.teamSettingPop == true && this.selectedTeams.length == 0) {
                alert('팀을 선택해주세요.');
                return;
            }
            this.isSaving = true;
            api.post(`/admin/api/center/${this.centerId}/team/assign`, {
                centerStaffIds: [...this.selectedStaffs],
                centerTeamIds: [...this.selectedTeams],
            })
                .then((res) => {
                    this.isSaving = false;
                    this.teamSettingPop = false;
                    this.selectedStaffs = [];
                    this.selectedTeams = [];
                    this.loadStaff();
                })
                .catch((res) => {
                    this.isSaving = false;
                    if (res.response.status != 404) alert(`오류가 발생했습니다.\n${res.response.data.message}`);
                    console.error(res);
                });
        },
        removeStaffTeams() {
            if (this.selectedStaffs.length == 0) {
                alert('팀에서 제외할 직원을 선택해주세요.');
                return;
            }
            if (!confirm('팀에서 선택한 직원을 제외하시겠습니까?')) {
                return;
            }
            this.isSaving = true;
            api.delete(
                `/admin/api/center/${this.centerId}/team/deleteTeam/staffs?teamIds=${
                    this.selectedTeamId
                }&staffIds=${this.selectedStaffs.join(',')}`
            )
                .then((res) => {
                    this.isSaving = false;
                    this.selectedStaffs = [];
                    this.loadStaff();
                })
                .catch((res) => {
                    this.isSaving = false;
                    if (res.response.status != 404) alert(`오류가 발생했습니다.\n${res.response.data.message}`);
                    console.error(res);
                });
        },
        // staff image 없을 경우 default image 표시
        imageUrlAlt(event) {
            event.target.src = '/img/temp/no_photo.jpg';
        },
    },
};
</script>
<style lang="scss"></style>
